export default [
  {
    path: '/main/equipments-data',
    meta: {
      tag: 'editequipmentsdata',
      name: 'Editar Equipamento',
      breadcrumb: 'Editar Equipamento',
      menu: 'settings'
    },
    component: () => import(/* webpackChunkName: "editequipment-list" */ '@/views/main/settings/stock-registers/editEquipment/Edit.vue')
  }
]